import { render, staticRenderFns } from "./PrintHistory.vue?vue&type=template&id=31990636"
import script from "./PrintHistory.vue?vue&type=script&lang=js"
export * from "./PrintHistory.vue?vue&type=script&lang=js"
import style0 from "./PrintHistory.vue?vue&type=style&index=0&id=31990636&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports